import { PaginationInterfaceLF } from ".";

export interface Permission {
  id: number;
  keyName: string;
  displayName: string;
  description: string;
  permissionSectionId: number;
  sectionName?: string;
}

export interface EnhancedPermission extends Permission {
  effect: "Allow" | "Deny";
}

export interface PermissionSection {
  id: number;
  name: string;
}
export interface PermissionsListAPIResponse {
  data: Permission[];
  included: {
    permissionSections: PermissionSection[];
  };
}
export interface Staff {
  id: number;
  userId: number;
  privilegeId: number;
  name: string;
  email: string;
  phoneNumber: string;
  lastAccessDate: string;
  status: string;
  createdAt: string;
  privilegeName?: string;
}
export interface Privilege {
  id: number;
  name: string;
  descriptions: string;
}

export interface StaffListApiResponse {
  data: Staff[];
  included: {
    privileges: Privilege[];
  };
  pagination: PaginationInterfaceLF;
}
export interface PostStaffApiPayload {
  privilegeId: number;
  name: string;
  email: string;
  phoneNumber: string;
  password?: string;
  status: string;
}
export interface PostStaffApiResponse {
  data: { id: number };
}
export interface PermissionsDetails {
  id: number;
  key: string;
  displayName: string;
  description: string;
  permissionSectionId: number;
  effect: string;
}
export interface GetStaffPermissionsApiResponse {
  data: {
    identityId: number;
    defaults: PermissionsDetails[];
    overrides: PermissionsDetails[];
    included: {
      permissionSections: PermissionSection[];
    };
  };
}

export interface GetPrivilegesApiResponse {
  data: Privilege[];
}

export interface PutPermissionsApiResponse {
  data: string;
}
export interface AssignedStores {
  entityId: number;
  entityType: string;
  storeName: string;
}
export interface GetAssignedStoresApiResponse {
  data: AssignedStores[];
}
interface ExpressStores {
  id: number;
  name: string;
  type: string;
}
export interface BranchesAndStores {
  id: number;
  name: string;
  type: string;
  expressStores: ExpressStores[];
}
export interface GetBranchesAndStoresApiResponse {
  data: BranchesAndStores[];
}
export interface AssignStoreApiResponse {
  data: string;
}
export interface AssignStoreApiPayload {
  staffIdentityId: number;
  storeId: number;
  expressStoreId: number;
  storeType: string;
}

export interface PermissionsListByPrivilegeIdAPIResponse {
  data: {
    permissionId: number;
    effect: "Allow" | "Deny";
  }[];
  included: {
    permissions: Permission[];
    permissionSections: PermissionSection[];
  };
}

// types
interface SectionRow {
  isSection: true;
  section: string;
}

export type EnhancedPermissionRow = EnhancedPermission & { isSection: false };
export type EnhancedPermissionTableRow = SectionRow | EnhancedPermissionRow;

export interface PermissionAssignmentPayload {
  privilegeId: number;
  permissions: {
    permissionId: number;
    effect: "Allow" | "Deny";
  }[];
}

export interface PostAssignPermissionToPrivilegeApiResponse {
  data: string;
}
export interface Configurations {
  storeId: number;
  changeFeature: boolean;
  renewFeature: boolean;
  appUnderMaintenance: boolean;
  freeSubscriptionFeature: boolean;
  invitationFeature: boolean;
  onDemandFeature: boolean;
  onDemandLiveTrack: boolean;
  onDemandWithBalanceFeature: boolean;
  chatFeature: boolean;
  coreGroup: boolean;
  customGroup: boolean;
  personalizedGroup: boolean;
  contactCall: boolean;
  contactWhatsapp: boolean;
}
export interface GetConfigurationsAPIResponse {
  data: Configurations;
}
export enum PermissionKeys {
  SUBSCRIPTION_VIEW = "subscription.view",
  SUBSCRIPTION_MANAGE = "subscription.manage",
  SUBSCRIPTION_REPORTS_DOWNLOAD = "subscription.reports.download",
  SUBSCRIPTION_REPORTS_DOWNLOAD_CONFIRMED_BOXES = "subscription.reports.download_confirmed_boxes",
  SUBSCRIPTION_REPORTS_DOWNLOAD_AUTO_MEAL = "subscription.reports.download_auto_meal",
  SUBSCRIPTION_CANCEL = "subscription.cancel",
  CLIENTS_VIEW = "clients.view",
  CLIENTS_MANAGE = "clients.manage",
  CLIENTS_REPORTS_DOWNLOAD = "clients.reports.download",
  DELIVERY_VIEW = "delivery.view",
  DELIVERY_MANAGE = "delivery.manage",
  DELIVERY_REPORTS_DOWNLOAD = "delivery.reports.download",
  WALLET_VIEW = "wallet.view",
  WALLET_MANAGE = "wallet.manage",
  WALLET_SEEDS_CANCEL = "wallet.seeds.cancel",
  MEALS_VIEW = "meals.view",
  MEALS_MANAGE = "meals.manage",
  CUSTOM_MEALS_VIEW = "custommeals.view",
  CUSTOM_MEALS_MANAGE = "custommeals.manage",
  ORDERS_VIEW = "orders.view",
  ORDERS_MANAGE = "orders.manage",
  PRODUCTION_VIEW = "production.view",
  PRODUCTION_MANAGE = "production.manage",
  PRODUCTION_SEARCH_CONFIRMED_BOXES = "production.search_confirmed_boxes",
  PRODUCTS_VIEW = "products.view",
  PRODUCTS_MANAGE = "products.manage",
  PRODUCTS_MANAGE_STATUS = "products.manage_status",
  STOCKS_VIEW = "stocks.view",
  STOCKS_MANAGE = "stocks.manage",
  CONFIGURATION_VIEW = "configuration.view",
  CONFIGURATION_MANAGE = "configuration.manage",
  PROMOTION_VIEW = "promotion.view",
  PROMOTION_MANAGE = "promotion.manage",
  PROMOTION_REPORTS_DOWNLOAD = "promotion.downloadreport",
  PACKAGES_VIEW = "packages.view",
  PACKAGES_MANAGE = "packages.manage",
  PRICEPLANS_MANAGE = "priceplans.manage",
  PRICEPLAN_VIEW = "priceplan.view",
  ANALYTICS_VIEW = "analytics.view",
  ANALYTICS_MANAGE = "analytics.manage",
  STAFF_MANAGE = "staff.manage",
  GROUPS_VIEW = "groups.view",
  GROUPS_MANAGE = "groups.manage",
  ALLERGIES_VIEW = "allergies.view",
  ALLERGIES_MANAGE = "allergies.manage",
  NOTIFICATION_CAMPAIGN_VIEW = "notificationcampaign.view",
  NOTIFICATION_CAMPAIGN_MANAGE = "notificationcampaign.manage",
  ANALYTICS_REVENUE_VIEW = "analytics.revenue.view",
  MEALS_AUDITLOGS_VIEW = "meals.auditlogs.view",
  CATALOG_IMPORT_VIEW = "catalog.import",
  CATALOG_IMPORTLOGS_VIEW = "catalog.importlogs.view",
}